module.exports = __webpack_public_path__ + "static/img/輾二-張宗賢.1686c19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/輾二-張宗賢.jpg
// module id = cP7I
// module chunks = 1